"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemVariablesWithTypes = exports.TemplateSystemVariables = exports.ITemplateVariable = void 0;
class ITemplateVariable {
}
exports.ITemplateVariable = ITemplateVariable;
exports.TemplateSystemVariables = ['subscriber', 'step', 'branding'];
exports.SystemVariablesWithTypes = {
    subscriber: {
        firstName: 'string',
        lastName: 'string',
        email: 'string',
        phone: 'string',
        avatar: 'string',
        subscriberId: 'string',
    },
    step: {
        digest: 'boolean',
        events: 'array',
        total_count: 'number',
    },
    branding: {
        logo: 'string',
        color: 'string',
    },
};
